import React from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import MintButton from "src/component/MintButton";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  bannerBox: {
    position: "relative",
    backgroundImage: "url(./images/banner/banner.png)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "200px 0px",
    zIndex: "1",
    [theme.breakpoints.down("sm")]: {
      padding: "50px 0px 50px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "20px 0px 45px",
    },

    [theme.breakpoints.down("md")]: {
      height: "auto",
    },
    "& img": {
      maxWidth: "100%",
    },
    "& .square": {
      position: "absolute",
      top: "150px",
      width: "250px",
      left: "50px",
      [theme.breakpoints.down("md")]: {
        width: "200px",
      },
      [theme.breakpoints.down("sm")]: {
        position: "initial",
        width: "40%",
        margin: "0 20px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
    },
    "& .Triangle": {
      position: "absolute",
      bottom: "50px",
      width: "250px",
      left: "50px",
      [theme.breakpoints.down("md")]: {
        width: "200px",
      },
      [theme.breakpoints.down("sm")]: {
        position: "initial",
        width: "40%",
        margin: "0 20px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
    },
  },
  maintext: {
    [theme.breakpoints.down("sm")]: {
      margin: "50px 0",
    },
    "& p": {
      color: "#ffffff",
      textAlign: "center",
      fontSize: "20px",
      marginBottom: "35px",
      marginTop: "10px",
      fontWeight: 400,
      lineHeight: "25px",
      width: "100%",
      maxWidth: "690px",
      margin: "0 auto",
      [theme.breakpoints.down("md")]: {
        fontSize: "20px",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "15px",
        overflow: "inherit",
        lineHeight: "21px",
      },
    },
    "& h1": {
      color: "#EFBD31",
      textAlign: "center",
      fontSize: "100px",
      fontWeight: "400",
      marginBottom: "30px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "40px",
        marginBottom: "0px",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "35px",
        marginBottom: "0px",
      },
    },
    "& button": {
      margin: "0 5px",
    },

    "& figure": {
      width: "900px",
      display: "flex",
      justifyContent: "center",
      margin: "0 auto",
      height: "auto",
      overflow: "hidden",
      [theme.breakpoints.down("md")]: {
        width: "250px",
      },
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        overflow: "inherit",
      },

      "& img": {
        width: "100%",
        transition: "02s",
        [theme.breakpoints.down("xs")]: {
          width: "100%",
        },
      },
    },
  },
  btnstyle: {
    marginLeft: "20px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "0px",
    },
  },
  boxbutton: {
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
    justifyContent: "center",
  },
  btnmain: {
    textAlign: "center",
  },
  btnsize: {
    fontSize: "20px",
    fontWeight: "600",
  },
}));

export default function BestSeller() {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Box className={classes.bannerBox}>
      <Container maxWidth='md'>
        <Box className={classes.maintext}>
          {/*<figure>
            <img src="images/roontext.png" alt="pic" />
          </figure>*/}
          <Box>
            <Typography variant='h1'>RoonScape</Typography>
          </Box>
          <Typography variant='body2'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Senectus
            est egestas magna vulputate aliquet placerat lectus etiam venenatis.
            Consequat augue feugiat ullamcorper elit at.{" "}
          </Typography>
          <Box align='center' mb={3} mt={6}>
            <Box className={classes.boxbutton}>
              <Box textAlign='center'>
                <MintButton
                  onClick={() => {
                    history.push("/mint");
                  }}
                />
              </Box>
              <Box textAlign='center' className={classes.btnmain}>
                <Button
                  className={classes.btnmobile}
                  variant='contained'
                  color='secondary'
                  size='large'
                  component={Link}
                  to='/'
                >
                  Whitepaper
                </Button>
              </Box>
            </Box>
            {/*-------*/}

            {/*<Button variant="contained" color="primary" size="small" component={Link} to="/main-game" style={{marginLeft:"10px"}}>
              Start Game
            </Button>*/}
          </Box>
        </Box>
      </Container>
      {/* <img src="images/Triangle.png" className="Triangle" alt="" />
      <img src="images/Circle.png" className="Circle" alt="" /> */}
    </Box>
  );
}
